import { createI18n } from 'vue-i18n';
import en from './en';
import hi from './hi';

const STORAGE_KEY = 'hks-locale';

function initialLocale() {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === 'en' || saved === 'hi') return saved;
  } catch (e) {
    // localStorage unavailable (private mode, etc.) — fall back to default.
  }
  return 'en';
}

const i18n = createI18n({
  legacy: true, // Options API components use this.$t / $t() in templates
  globalInjection: true,
  locale: initialLocale(),
  fallbackLocale: 'en',
  messages: { en, hi },
});

export function setLocale(locale) {
  i18n.global.locale = locale;
  document.documentElement.lang = locale;
  try {
    window.localStorage.setItem(STORAGE_KEY, locale);
  } catch (e) {
    // ignore write failures
  }
}

export default i18n;
